import { apiClient } from "./client";

export type PlanBlancSeverity = "ALPHA" | "BRAVO" | "CHARLIE";

export type PlanBlancEvent = {
  id: string;
  organization_id: string;
  severity: PlanBlancSeverity;
  declared_by_user_id: string | null;
  declared_at: string;
  reason: string | null;
  ended_at: string | null;
  ended_by_user_id: string | null;
  end_reason: string | null;
  practitioners_notified: number;
  is_active: boolean;
};

export type PlanBlancState = {
  active: PlanBlancEvent | null;
  history: PlanBlancEvent[];
};

export async function getPlanBlancState(orgId: string): Promise<PlanBlancState> {
  const { data } = await apiClient.get<PlanBlancState>(
    `/api/v1/organizations/${orgId}/plan-blanc`,
  );
  return data;
}

export async function listActivePlanBlancs(): Promise<PlanBlancEvent[]> {
  const { data } = await apiClient.get<PlanBlancEvent[]>(
    "/api/v1/organizations/plan-blanc/active",
  );
  return data;
}

export async function declarePlanBlanc(
  orgId: string,
  severity: PlanBlancSeverity,
  reason?: string,
): Promise<PlanBlancEvent> {
  const { data } = await apiClient.post<PlanBlancEvent>(
    `/api/v1/organizations/${orgId}/plan-blanc/declare`,
    { severity, reason: reason || null },
  );
  return data;
}

export async function endPlanBlanc(
  orgId: string,
  endReason?: string,
): Promise<PlanBlancEvent> {
  const { data } = await apiClient.post<PlanBlancEvent>(
    `/api/v1/organizations/${orgId}/plan-blanc/end`,
    { end_reason: endReason || null },
  );
  return data;
}
